import { Container } from "./styled";

const Body = (props) => {
  return <Container>{props.children}</Container>;
};

export default Body;
